import { useWriteOffBankSlip } from '@/core/domain/financial/Boletos/Boletos.hooks';
import { useBankSlipFormContext } from '@/pages/FinancialPages/BankSlipPage';
import { Button, Modal, Typography, notification } from 'antd';
import BankSlipReturnFileModal from './BankSlipWriteOffModal';
import { useDisclosure } from '@/hooks';
import { BilletsStatus } from '@/core/domain/financial/Boletos/Boletos.types';

export default function WriteOffButton() {
  const { queryParams, selectedBankSlips } = useBankSlipFormContext();

  const [writeOffOpened, writeOffAction] = useDisclosure();

  const writeOffMutation = useWriteOffBankSlip();

  const handleWritteOff = async () => {
    if (queryParams.companyId && selectedBankSlips.length) {
      const response = await writeOffMutation.mutateAsync({
        companyId: queryParams.companyId,
        installmentReceivableBillsIds: selectedBankSlips.map((item) => item.id),
      });

      if (response.message && response.protocol) {
        Modal.confirm({
          title: 'Resposta da Solicitação de baixa',
          content: (
            <>
              <p>
                <strong>Messagem: </strong>
                <Typography.Text>{response.message}</Typography.Text>
              </p>

              <p>
                <strong>Protocolo: </strong>
                <Typography.Text>{response.protocol}</Typography.Text>
              </p>
            </>
          ),
        });
      }
    } else {
      notification.error({
        message: 'Selecione uma empresa e ao menos um boleto',
      });
    }
  };

  return (
    <>
      <Button
        block
        type="primary"
        onClick={writeOffAction.open}
        disabled={
          !selectedBankSlips.length &&
          !selectedBankSlips.some((item) =>
            [BilletsStatus.registred, BilletsStatus.emited].includes(
              item.status,
            ),
          )
        }
      >
        Solicitar baixa
      </Button>

      <BankSlipReturnFileModal
        onCallback={handleWritteOff}
        companyId={queryParams.companyId}
        open={writeOffOpened}
        onCancel={writeOffAction.close}
      />
    </>
  );
}
